import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import type { SanityDocument } from "@sanity/client";


export default /*@__PURE__*/_defineComponent({
  __name: 'refund-policy',
  async setup(__props) {

let __temp: any, __restore: any

definePageMeta({
  layout: "default",
  pageTransition: { name: "page", mode: "out-in" },
});

useHead({
  title: "Refund Policy",
  meta: [{ name: "description", content: "Refund Policy FamilyAxis" }],
  bodyAttrs: {
    class: "Refund Policy",
  },
});

defineOgImage("MainOg", {
  title: "Refund Policy - FamilyAxis",
  description: "Understand FamilyAxis’ refund terms for subscriptions and services.",
  theme: "#f5f5f5",
  colorMode: "light",
});

useSeoMeta({
  title: "Refund Policy | FamilyAxis",
  description: "Read FamilyAxis’ Refund Policy for subscriptions and services.",
  keywords: "refund policy, billing, subscriptions, FamilyAxis refund",
  author: "FamilyAxis",
  ogTitle: "Refund Policy | FamilyAxis",
  ogDescription: "Our refund terms and conditions.",
  ogUrl: "https://familyaxis.com/refund-policy",
  ogType: "website",
  ogSiteName: "FamilyAxis",
  twitterCard: "summary_large_image",
  twitterTitle: "Refund Policy | FamilyAxis",
  twitterDescription: "Read our refund terms for subscriptions and services.",
  twitterSite: "@familyaxis",
  robots: "index, follow",
});

const POST_QUERY = groq`*[_type == "page" && slug.current == "refund-policy"][0]`;
const { data: post } = (
  ([__temp,__restore] = _withAsyncContext(() => useSanityQuery<SanityDocument>(POST_QUERY))),
  __temp = await __temp,
  __restore(),
  __temp
);

return (_ctx: any,_cache: any) => {
  const _component_UPageHero = _resolveComponent("UPageHero")!
  const _component_ContentSanity = _resolveComponent("ContentSanity")!
  const _component_UPage = _resolveComponent("UPage")!
  const _component_UContainer = _resolveComponent("UContainer")!

  return (_openBlock(), _createBlock(_component_UContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_UPage, { class: "px-5 md:px-32" }, {
        default: _withCtx(() => [
          _createVNode(_component_UPageHero, {
            title: "Refund Policy",
            description: `Last updated: ${_ctx.formatDateString(_unref(post)?._updatedAt)}`
          }, null, 8, ["description"]),
          (_unref(post)?.body)
            ? (_openBlock(), _createBlock(_component_ContentSanity, {
                key: 0,
                blocks: _unref(post)?.body,
                page: "refund-policy"
              }, null, 8, ["blocks"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})